import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Self-hosted Lexend (SIL OFL 1.1; ADR 0011): no runtime requests to font CDNs.
import '@fontsource/lexend/400.css';
import '@fontsource/lexend/500.css';
import '@fontsource/lexend/700.css';
import './design-tokens/tokens.css';
import '@ebu/ui/ui.css';
import './app/app.css';
import { App } from './app/App';
import { sendClientErrorReport } from './adapters/api-client';
import { BrowserLogger } from './diagnostics/browser-logger';
import { installGlobalErrorHandlers } from './diagnostics/global-handlers';
import { APP_VERSION } from './version';

const logger = new BrowserLogger({
  idbFactory: typeof indexedDB === 'undefined' ? undefined : indexedDB,
  appVersion: APP_VERSION,
  reporter: (report) => sendClientErrorReport(report),
});
installGlobalErrorHandlers(logger);
void logger.init();
logger.info('web-shell', `Kids World web ${APP_VERSION} started`);

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element in index.html');

createRoot(container).render(
  <StrictMode>
    <App logger={logger} />
  </StrictMode>,
);
